// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dQ38U","errorDots":"styles_errorDots__hlf3J","dots":"styles_dots__DGZ6v","blink":"styles_blink__jX1MT"};